const PALETTE = [
    '#DC2626', '#2563EB', '#059669', '#D97706', '#7C3AED',
    '#DB2777', '#0891B2', '#65A30D', '#EA580C', '#4F46E5',
    '#0D9488', '#9333EA', '#B45309', '#BE123C',
];

export const buildSellerColors = (sellers) => {
    const sorted = [...sellers].sort((a, b) => a.name.localeCompare(b.name));
    const map = {};
    sorted.forEach((s, i) => { map[s.id] = PALETTE[i % PALETTE.length]; });
    return map;
};

export const initials = (name = '') =>
    name.split(' ').filter(Boolean).slice(0, 2).map(p => p[0].toUpperCase()).join('');
